import React from 'react';
import enhance from './enhance';

export const AddToCartButton = ({
  addToCartString,
  submitToCart,
  disabledButton,
  buttonStyle,
  buttonTheming,
}) => {
  return (
    <button
      onClick={submitToCart}
      className={buttonStyle}
      style={buttonTheming}
      disabled={disabledButton}
    >
      {addToCartString}
    </button>
  );
};

export default enhance(AddToCartButton);
